export default __webpack_public_path__ + "370c13f8f6851fb794c9d66fc02e4603.svg";